import { createFileRoute } from "@tanstack/react-router";
import { parseLedgerSearch } from "@/features/album-manager/ledger-search";

/** Sổ album ngoài đơn (QĐ 0306) — tháng và cơ sở nằm trên đường dẫn. */
export const Route = createFileRoute("/_app/albums/ledger")({
  validateSearch: parseLedgerSearch,
});
